import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, inject, PLATFORM_ID } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-wa-sample-request-restriction',
  standalone: true,
  imports: [],
  templateUrl: './modal-wa-sample-request-restriction.component.html',
  styleUrl: './modal-wa-sample-request-restriction.component.scss'
})
export class ModalWaSampleRequestRestrictionComponent {
  activeModal = inject(NgbActiveModal);

  constructor(@Inject(PLATFORM_ID) private platformId: any) { }

  openContactEmail() {
    if (isPlatformBrowser(this.platformId)) {
      let url = 'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=hi@gatherco.com.au&su=Your+Subject+here&ui=2&tf=1&pli=1'
      window.open(url, 'sharer', 'toolbar=0,status=0,width=648,height=395');
    }
  }
}
